module.exports = __webpack_public_path__ + "static/img/head-default.d103a46a.png";